import { render, staticRenderFns } from "./PluginsCircuitBg.vue?vue&type=template&id=4cb1d4ff&scoped=true"
import script from "./PluginsCircuitBg.vue?vue&type=script&lang=ts"
export * from "./PluginsCircuitBg.vue?vue&type=script&lang=ts"
import style0 from "./PluginsCircuitBg.vue?vue&type=style&index=0&id=4cb1d4ff&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cb1d4ff",
  null
  
)

export default component.exports